import { FONT } from "@/styles/common";
import { Textarea } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomWrapper = styled(Textarea)`
    width: 100%;
    height: 152px;
    padding: 16px;
    overflow-y: scroll;
    ${FONT("pretendard", 14, 300, 1.5)};
    border: 1px solid #f8f8f8 !important;
    border-radius: 8px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    color: ${({ theme }) => theme.COLOR.black};
    resize: none;
`;
